const prefix = 'pp.admin/orders/dashboard'

const GET_DASHBOARD_DATA = `${prefix}/GET_DASHBOARD_DATA`
const SET_DASHBOARD_DATA = `${prefix}/SET_DASHBOARD_DATA`
const CLEAR_DASHBOARD_DATA = `${prefix}/CLEAR_DASHBOARD_DATA`

const SET_DASHBOARD_PARAMS = `${prefix}/SET_DASHBOARD_PARAMS`

const GET_DASHBOARD_WIDGETS_DATA = `${prefix}/GET_DASHBOARD_WIDGETS_DATA`
const SET_DASHBOARD_WIDGETS_IS_LOADING = `${prefix}/SET_DASHBOARD_WIDGETS_IS_LOADING`
const SET_DASHBOARD_WIDGET_DATA = `${prefix}/SET_DASHBOARD_WIDGET_DATA`

const GET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL = `${prefix}/GET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL`
const SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL = `${prefix}/SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL`

const SET_OPENED_HEADER = `${prefix}/SET_OPENED_HEADER`

const SET_DASHBOARD_PARTNER = `${prefix}/SET_DASHBOARD_PARTNER`
const SHOW_DASHBOARD_PARTNER_SELECT = `${prefix}/SHOW_DASHBOARD_PARTNER_SELECT`
const HIDE_DASHBOARD_PARTNER_SELECT = `${prefix}/HIDE_DASHBOARD_PARTNER_SELECT`
const DASHBOARD_SHOW_SIGNING_ACTS = `${prefix}/DASHBOARD_SHOW_SIGNING_ACTS`

const GET_DASHBOARD_AVAILABLE_PRODUCTS = `${prefix}/GET_DASHBOARD_AVAILABLE_PRODUCTS`
const SET_DASHBOARD_AVAILABLE_PRODUCTS = `${prefix}/SET_DASHBOARD_AVAILABLE_PRODUCTS`
const SHOW_DASHBOARD_PARTNER_PAYMENT = `${prefix}/SET_DASHBOARD_PARTNER_PAYMENT`
const UPDATE_MOTIVATION_WIDGET = `${prefix}/UPDATE_MOTIVATION_WIDGET`

export const dashboardConstants = {
	GET_DASHBOARD_DATA,
	SET_DASHBOARD_DATA,
	CLEAR_DASHBOARD_DATA,
	SET_DASHBOARD_PARAMS,
	GET_DASHBOARD_WIDGETS_DATA,
	SET_DASHBOARD_WIDGET_DATA,
	GET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL,
	SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL,
	SET_OPENED_HEADER,
	SET_DASHBOARD_PARTNER,
	SHOW_DASHBOARD_PARTNER_SELECT,
	HIDE_DASHBOARD_PARTNER_SELECT,
	DASHBOARD_SHOW_SIGNING_ACTS,
	GET_DASHBOARD_AVAILABLE_PRODUCTS,
	SET_DASHBOARD_AVAILABLE_PRODUCTS,
	SET_DASHBOARD_WIDGETS_IS_LOADING,
	SHOW_DASHBOARD_PARTNER_PAYMENT,
	UPDATE_MOTIVATION_WIDGET,
}
